<script>
import { Line } from 'vue-chartjs'
import { getStyle, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'
import { CustomTooltips } from '@coreui/coreui-plugin-chartjs-custom-tooltips'
import { random } from '@/shared/utils'
import DateFormatter from '../../plugins/dateFormatter'

export default {
  extends: Line,
  props: ['height', 'renderData'],
  data () {
    return {
      maximumRevenue: 0,
      dates: [],
      ticksLimit : 0,
      filterDates : [],
      chartData : {},
      onedioTotalArray: [],
      onedioTotal: 0,
      labelName: '',
      service : '',
      labelName : '',
      selectedData: '',
      datasetArray: [],
      mycolor: '#000',
      facebookColor: '#023AA3',
      yandexColor: '#EF2E2E',
      relapColor: '#2DA87D',
      adxColor: '#FFA000',
      adformColor: '#BC4C9E',
      forColor: '',
      generalTotal: 0,
      dolarTo: 0,
      rubleTo: 0,
      tlTo:0,
      selectedSites: '',
      onedioruDatas: '',
      onediocoDatas: '',
      onediocomDatas: '',
      selectedCurrency:'TRY'
    }
  },
  watch: {
    async renderData(newData, oldData){
      this.service = await this.$store.state.optionSelectedService
      if(this.service === 'yandex'){
        this.service = 'yandex_ads'
      }
      this.selectedData = await this.$store.state.selectedData
      this.selectedSites = await this.$store.state.selectedSites
      this.filterDates = await this.$store.state.itemsData.filterDates
      this.selectedCurrency=await this.$store.state.selectedCurrency
      await this.changeChartData()
      /* await this.$store.dispatch('GENERAL_TOTAL',this.generalTotal) */
       await this.$events.fire('SET_GENERAL_TOTAL_MAIN',this.generalTotal)
    }
  },
  async created(){
      this.selectedData = await this.$store.state.selectedData
      this.service = await this.$store.state.optionSelectedService
      this.selectedSites = await this.$store.state.selectedSites
      this.filterDates = await this.$store.state.itemsData.filterDates
      this.selectedCurrency=await this.$store.state.selectedCurrency
      if(this.service[0] === 'yandex'){
        this.service[0] = 'yandex_ads'
      }  
      if(this.$store.state.dolar.rates){
        this.dolarTo = await this.$store.state.dolar.rates[(this.selectedCurrency)]
        this.rubleTo = await this.$store.state.ruble.rates[(this.selectedCurrency)]
        this.tlTo = await this.$store.state.tl.rates[(this.selectedCurrency)]
      }
      await this.changeChartData()
      /* this.generalTotal=await this.$store.state.generalTotal */
       await this.$events.fire('SET_GENERAL_TOTAL_MAIN',this.generalTotal)
  },
  async mounted () {
      await this.changeChartData();    
  },
  
  methods: {
    async changeChartData(){
    const brandSuccess = getStyle('--success') || '#4dbd74'
    const brandInfo = getStyle('--info') || '#20a8d8'
    const brandDanger = getStyle('--danger') || '#f86c6b'
    this.maximumRevenue = 0;
    let dataInfo = false
    if(this.$store.state.itemsData.filterDates){
    this.chartData = await this.$store.state.itemsData.datas[0]
    this.onediocomDatas = await this.chartData.onediocomDatas
    this.onediocoDatas = await this.chartData.onediocoDatas
    this.onedioruDatas = await this.chartData.onedioruDatas
    let mom = this

    this.filterDates = await this.$store.state.itemsData.filterDates;
    this.selectedSites=await this.$store.state.selectedSites
    this.selectedData = await this.$store.state.selectedData
    this.service = await this.$store.state.optionSelectedService
    this.selectedCurrency=await this.$store.state.selectedCurrency

    if(this.$store.state.dolar.rates){
      this.dolarTo = await this.$store.state.dolar.rates[(this.selectedCurrency)]
      this.rubleTo = await this.$store.state.ruble.rates[(this.selectedCurrency)]
      this.tlTo = await this.$store.state.tl.rates[(this.selectedCurrency)]
    }
    this.datasetArray = []
    this.generalTotal = 0
    this.selectedSites.forEach(async element => { 
      if(element === 'onediocom'){
        await this.filterSites(this.onediocomDatas,'onedio.com')
      }
      else if(element === 'onedioco'){
        await this.filterSites(this.onediocoDatas, 'onedio.co')
      }
      else if(element === 'onedioru'){
        await this.filterSites(this.onedioruDatas, 'onedio.ru')
      }
    });
   
   await this.$events.listen('SET_GENERAL_TOTAL_IN_MAIN',generalTotal => {
     this.generalTotal=generalTotal
   })
    if(this.selectedData!=="revenues" && this.selectedData!=="ad_requests" && this.selectedSites && this.$store.state.optionSelectedService){
      this.generalTotal/= await (this.selectedSites.length*this.$store.state.optionSelectedService.length)
      if(this.filterDates){
        this.generalTotal/= await this.filterDates.length
      }
    }
    /* await this.$store.dispatch('GENERAL_TOTAL',this.generalTotal)  */
    await this.$events.fire('SET_GENERAL_TOTAL_MAIN',this.generalTotal)
  let maxRevenue = 0
  function getMaximum(params) {
    params = Number(params)
      if (params > maxRevenue){
          maxRevenue = params;
      }
  }   
  Object.keys(this.datasetArray).forEach((item)=> {
    this.datasetArray[item].data.forEach(async (element) => {
     getMaximum(element)
    })
  })
  mom.maximumRevenue = maxRevenue;
  this.changeChart();
    }
  },
  async filterSites(site,siteName){
    let currency = ''
    this.service = await this.$store.state.optionSelectedService
    let count=0
    for(let k = 0;k < this.service.length; k++){
      this.onedioTotalArray = []
      this.service[k] = this.service[k].toLowerCase()
      this.filterDates.forEach(async (date,j) => {
        if(this.selectedData === 'revenues'){
          this.labelName = this.service[k]
          this.forColor = this.service[k] 
          site.revenues.value.forEach((element, i) => {
            if(date === site.revenues.date[i]){
              if(site.services[i] === this.service[k].toLowerCase()){
                currency = site.revenues.revenueTypes[i]
               
                if(currency=== '$'){
                  element=element*this.dolarTo
                  this.generalTotal+= element
                }
                else if(currency==='₽'){
                  element= element*this.rubleTo
                   this.generalTotal+=element
                }
                else{
                  element=element*this.tlTo
                  this.generalTotal += element
                }
                this.onedioTotal+=element
              }
            }
          });
          let selectedCurrency=this.selectedCurrency
          if(selectedCurrency==="TRY"){
            selectedCurrency='₺'
          }
          else if(selectedCurrency==="USD"){
            selectedCurrency='$'
          }
          else{
            selectedCurrency='₽'
          }
          this.labelName = siteName + ' ' + this.labelName + '(' + selectedCurrency + ')'
          this.onedioTotalArray.push(this.onedioTotal.toFixed(2))
          this.onedioTotal = 0;
        }
        else if(this.selectedData === 'impressions'){
        this.labelName = this.service[k]
          this.forColor = this.service[k] 
          site.impressions.forEach( (element, i) => {
            element = parseFloat(element.toFixed(2))
            element = parseFloat(element)
            if(date === site.revenues.date[i]){
              if(site.services[i] === this.service[k]){
                count+=1
                if(element >= 100){
                  element = parseFloat((element / site.ad_requests[i]) * 100).toFixed(2)
                }
                this.onedioTotal=Number(this.onedioTotal)
                this.onedioTotal+=Number(parseFloat(element).toFixed(2))
                this.onedioTotal=Number(this.onedioTotal)
              }
            }
          });
          if(count!==0){
            this.onedioTotal/=count
            count=0
          }
          this.labelName = siteName + ' ' + this.labelName
          this.onedioTotalArray.push(this.onedioTotal)
          this.generalTotal+=Number(this.onedioTotal)
          this.onedioTotal = 0;
        } 
        else if(this.selectedData === 'ad_requests'){
          this.labelName = this.service[k]
          this.forColor = this.service[k] 
          site.ad_requests.forEach((element, i) => {
            if(date === site.revenues.date[i]){
              if(site.services[i] === this.service[k]){
               /* if(element > 100000){ */
                 this.onedioTotal += element/1000
              /*  }
               else{
                 this.onedioTotal += element
               } */
              }
            }
          });
          this.labelName = siteName + ' ' + this.labelName
          this.onedioTotalArray.push(this.onedioTotal.toFixed(2).toString())
          this.generalTotal += this.onedioTotal
          this.onedioTotal = 0;
        }
        else if(this.selectedData === 'ctrs'){
          this.labelName = this.service[k]
          this.forColor = this.service[k] 
          site.ctrs.forEach((element, i) => {
            if(date === site.revenues.date[i]){
              if(site.services[i] === this.service[k]){
                this.onedioTotal += element
              }
            }
          });
          this.labelName = siteName + ' ' + this.labelName
          this.onedioTotalArray.push(this.onedioTotal.toFixed(5))
          this.generalTotal += this.onedioTotal
          this.onedioTotal = 0;
        }
        else if(this.selectedData === 'ecpms'){
          this.labelName = this.service[k]
                  this.forColor = this.service[k] 
          site.ecpms.forEach((element, i) => {
            if(date === site.revenues.date[i]){
              if(site.services[i] === this.service[k]){
                this.onedioTotal += element
              }
            }
          });
          this.labelName = siteName + ' ' + this.labelName
          this.onedioTotalArray.push(this.onedioTotal.toFixed(2))
          this.generalTotal += this.onedioTotal
          this.onedioTotal = 0;
        }
      })
      if(siteName === 'onedio.com'){
              if(this.forColor === 'facebook'){
        this.mycolor = this.facebookColor
      }else if(this.forColor === 'yandex_ads'){
        this.mycolor = this.yandexColor
      }else if(this.forColor === 'relap'){
        this.mycolor = this.relapColor
      }else if(this.forColor === 'adx'){
        this.mycolor = this.adxColor
      }else if(this.forColor === 'adform'){
        this.mycolor = this.adformColor
      }
      }else if(siteName === 'onedio.ru'){
      if(this.forColor === 'facebook'){
        this.mycolor = '#6a65d8'
      }else if(this.forColor === 'yandex_ads'){
        this.mycolor = '#ca3e47'
      }else if(this.forColor === 'relap'){
        this.mycolor = '#94DE00'
      }else if(this.forColor === 'adx'){
        this.mycolor = '#e8751a'
      }else if(this.forColor === 'adform'){
        this.mycolor = '#ca5fa6'
      }

      }
      else if(siteName === 'onedio.co'){  
      if(this.forColor === 'facebook'){
        this.mycolor = '#010059'
      }else if(this.forColor === 'yandex_ads'){
        this.mycolor = '#ff7a8a'
      }else if(this.forColor === 'relap'){
        this.mycolor = '#97de95'
      }else if(this.forColor === 'adx'){
        this.mycolor = '#ffd700'
      }else if(this.forColor === 'adform'){
        this.mycolor = '#ba78cd'
      }
      }
      const dataSetItem = 
        {
          label: this.labelName,
          backgroundColor: hexToRgba(this.mycolor, 5),
          borderColor: this.mycolor,
          pointHoverBackgroundColor: '#fff',
          borderWidth: 2,
          data: this.onedioTotalArray
        }
      this.datasetArray.push(dataSetItem)
    }
    await this.$events.fire('SET_GENERAL_TOTAL_IN_MAIN',this.generalTotal)
  }
  ,
  changeChart(){
    const brandSuccess = getStyle('--success') || '#4dbd74'
    const brandInfo = getStyle('--info') || '#20a8d8'
    const brandDanger = getStyle('--danger') || '#f86c6b'
    this.renderChart({
      labels: this.filterDates,
      datasets: this.datasetArray 
    }, {
      tooltips: {
        enabled: false,
        custom: CustomTooltips,
        intersect: true,
        mode: 'index',
        position: 'nearest',
        callbacks: {
          labelColor: function (tooltipItem, chart) {
            return { backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].borderColor }
          }
        }
      },
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          ticks: {
            maxTicksLimit: 18,
            stepSize: 1,
          },
          gridLines: {
            drawOnChartArea: true
          }
        }],
        yAxes: [{
          ticks: {
            beginAtZero: false,
            maxTicksLimit: this.ticksLimit,
            stepSize: 1,
            max: this.maximumRevenue
          },
          gridLines: {
            display: true
          }
        }]
      },
      elements: {
        point: {
          radius: 0,
          hitRadius: 10,
          hoverRadius: 4,
          hoverBorderWidth: 3
        }
      }
    })
  }
  },
}
</script>
